import React from 'react';
import PropTypes from 'prop-types';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

// Hook
import useBubbleCharts from '../../hooks/useBubbleCharts';

function BubbleDashboardVehicle({ plate }) {
  // Create chart instance
  const { bubbleData } = useBubbleCharts(plate);

  const chart = am4core.create('chartBubble', am4charts.XYChart);
  am4core.addLicense('ch-custom-attribution');
  am4core.options.autoDispose = true;

  const valueAxisX = chart.xAxes.push(new am4charts.ValueAxis());
  valueAxisX.renderer.ticks.template.disabled = true;
  valueAxisX.renderer.axisFills.template.disabled = true;
  valueAxisX.title.text = 'Km (x100)';

  const valueAxisY = chart.yAxes.push(new am4charts.ValueAxis());
  valueAxisY.renderer.ticks.template.disabled = true;
  valueAxisY.renderer.axisFills.template.disabled = true;
  valueAxisY.title.text = '% de salud';

  const series = chart.series.push(new am4charts.LineSeries());
  series.dataFields.valueX = 'x';
  series.dataFields.valueY = 'y';
  series.dataFields.value = 'value';
  series.strokeOpacity = 0;
  series.sequencedInterpolation = true;
  series.tooltip.pointerOrientation = 'vertical';
  series.tooltipText = '[bold]{title}[/]';

  const bullet = series.bullets.push(new am4core.Circle());
  bullet.fill = am4core.color('#FF6633');
  bullet.propertyFields.fill = '#FF6633';
  bullet.strokeOpacity = 0;
  bullet.strokeWidth = 2;
  bullet.fillOpacity = 0.5;
  bullet.stroke = am4core.color('#ffffff');
  bullet.hiddenState.properties.opacity = 0;

  const outline = chart.plotContainer.createChild(am4core.Circle);
  outline.fillOpacity = 0;
  outline.strokeOpacity = 0.8;
  outline.stroke = am4core.color('#FF6633');
  outline.strokeWidth = 2;
  outline.hide(0);

  const blurFilter = new am4core.BlurFilter();
  outline.filters.push(blurFilter);

  bullet.events.on('over', (event) => {
    const { target } = event;
    outline.radius = target.pixelRadius + 2;
    outline.x = target.pixelX;
    outline.y = target.pixelY;
    outline.show();
  });

  bullet.events.on('out', () => {
    outline.hide();
  });

  const hoverState = bullet.states.create('hover');
  hoverState.properties.fillOpacity = 1;
  hoverState.properties.strokeOpacity = 1;

  series.heatRules.push({ target: bullet, min: 6, max: 6, property: 'radius' });

  bullet.adapter.add('tooltipY', (tooltipY, target) => -target.radius);

  chart.cursor = new am4charts.XYCursor();
  chart.cursor.behavior = 'zoomXY';
  chart.cursor.snapToSeries = series;

  chart.data = bubbleData;

  // Enable export
  chart.exporting.menu = new am4core.ExportMenu();

  return (
    <div className="row no-gutters charDashboard2">
      <div className="col" id="chartBubble" />
    </div>
  );
}

BubbleDashboardVehicle.propTypes = {
  plate: PropTypes.string.isRequired,
};

export default BubbleDashboardVehicle;
